import useSWR, { SWRConfiguration } from "swr";
import { useEffect } from "react";
// import { useRouter } from "@/i18n/routing";

const fetcher = async (url: string) => {
  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    return Promise.reject({
      status: res.status,
      statusText: res.statusText,
      body: await res.json(),
    });
  }
  return res.json();
};

export default function useSWRFetcher<T>(url: any, config?: SWRConfiguration) {
  const swr = useSWR<T>(url, fetcher, {
    // refreshInterval: 1000 * 10
    ...config,
  });
  // const router = useRouter();
  useEffect(() => {
    if (swr.error) {
      console.error("SWR Fetcher Error: ", swr.error);
      if (swr.error.status === 401) {
        location.reload();
        // Handle unauthorized error, e.g., redirect to login page
        // router.push("/logout");
      }
    }
  }, [swr.error]);

  return swr;
}
